import type { SpecNextStep } from '../../../lib/api/spec-requirements.js';
import { NextStepCard } from './NextStepCard.js';
import { PlReviewPanel } from './PlReviewPanel.js';

export interface ProjectStatusCardsProps {
  /** 案件キー */
  pjKey: string;
  /** 今いる工程とやること。読み込み中・失敗時は null */
  step: SpecNextStep | null;
}

/**
 * 案件を開いたときにいちばん上に並べる、案件全体の状況（次にやること・PL の承認状況）。
 *
 * 案件の画面（`SpecRequirementsView`）がコード行の上限に近いため、案件全体を指すカードは
 * ここにまとめて並べる。成果物ごとの操作はこれまでどおり各節に置く。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件の要件定義の次にやることと、案件全体に対する PL の承認・差し戻しを上部に並べる
 * @graph-connects NextStepCard [calls] 次にやること
 * @graph-connects PlReviewPanel [calls] 案件全体の PL の承認・差し戻し
 */
export function ProjectStatusCards({ pjKey, step }: ProjectStatusCardsProps) {
  return (
    <>
      <NextStepCard step={step} />
      <PlReviewPanel pjKey={pjKey} />
    </>
  );
}
